// DO NOT EDIT THIS FILE !!!! GENERATED DURING BUILD TYPE : Ansible
export const DOL_VERSION='[test]8.1-13268(f9f261ec57)-C28/10/2026-11:16:48-B28/10/2026-11:49:57' ;
export const DOL_VERSION_JSON = {
  dolVersion: "[test]8.1-13268(f9f261ec57)-C28/10/2026-11:16:48-B28/10/2026-11:49:57",
  branch: "test",
  latestTag: "8.1",
  revCount: "13268",
  shortHash: "f9f261ec57",
  longHash: "f9f261ec57913917e2fb4b5f66cc1eab76afb703",
  dateCommit: "28/10/2026-11:16:48",
  dateBuild: "28/10/2026-11:49:57",
  buildType: "Ansible",
  } ;
